import React from "react";
import AdminComponent from "../../components/admin/AdminComponent";

const AdminLogin = () => {
  return <AdminComponent />;
};

export default AdminLogin;
